function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.242,
    height: 16.243,
    viewBox: "0 0 16.242 16.243",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "x (3)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 15",
    transform: "translate(2.121 2.121)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    },
    d: "M12 0 0 12"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 16",
    transform: "translate(2.121 2.121)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    },
    d: "m0 0 12 12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX3);
export default __webpack_public_path__ + "static/media/x (3).70b6b2588a0ce0e1570fbb49a6a7b2d6.svg";
export { ForwardRef as ReactComponent };